import { type MutationHookOptions, useMutation } from "@apollo/client";
import { RequestVideoDownloadMutation } from "../graphql/mutations";
import type {
  RequestVideoDownloadMutationType,
  RequestVideoDownloadMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useRequestVideoDownloadMutation = (
  options?: MutationHookOptions<
    RequestVideoDownloadMutationType,
    RequestVideoDownloadMutationVariablesType
  >
) => {
  return useMutation<
    RequestVideoDownloadMutationType,
    RequestVideoDownloadMutationVariablesType
  >(RequestVideoDownloadMutation, options);
};
